var _defs, _use, _use2, _use3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimatedBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "AnimatedIcon__icon",
    width: 96,
    height: 96,
    preserveAspectRatio: "xMinYMin",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    "data-js-controller": "BlocksIcon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "blocksIconBack",
    d: "M30.68 31.37l9 4.15A4 4 0 0 1 42 39.15v10.89a4 4 0 0 1-2.32 3.63l-9 4.15a4 4 0 0 1-3.36 0l-9-4.15A4 4 0 0 1 16 50.04V39.15a4 4 0 0 1 .35-1.62L29 43.36v-1.54l-11.85-5.47a4 4 0 0 1 1.17-.83l9-4.15a4 4 0 0 1 3.36 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blocksIconFront",
    d: "M55 45.15v10.89a4 4 0 0 1-2.32 3.63l-9 4.15a4 4 0 0 1-3.36 0l-9-4.15A4 4 0 0 1 29 56.04V45.15a4 4 0 0 1 .35-1.62L42 49.37l12.65-5.84a4 4 0 0 1 .35 1.62zm-11.32-7.78l9 4.15a4 4 0 0 1 1.17.83L42 47.82l-11.86-5.47a4 4 0 0 1 1.18-.83l9-4.15a4 4 0 0 1 3.36 0z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "blocksIconClipPath"
  }, /*#__PURE__*/React.createElement("use", {
    "data-js-target-list": "BlocksIcon.firstBackBlocks",
    href: "#blocksIconFront",
    transform: "translate(-13, -6)",
    "data-js-bbox": "firstHiddenBlock"
  }), /*#__PURE__*/React.createElement("use", {
    "data-js-target-list": "BlocksIcon.secondBackBlocks",
    href: "#blocksIconFront",
    transform: "translate(-65, -30)",
    "data-js-bbox": "secondHiddenBlock"
  })), /*#__PURE__*/React.createElement("path", {
    id: "blocksIconFront",
    d: "M55 45.15v10.89a4 4 0 0 1-2.32 3.63l-9 4.15a4 4 0 0 1-3.36 0l-9-4.15A4 4 0 0 1 29 56.04V45.15a4 4 0 0 1 .35-1.62L42 49.37l12.65-5.84a4 4 0 0 1 .35 1.62zm-11.32-7.78l9 4.15a4 4 0 0 1 1.17.83L42 47.82l-11.86-5.47a4 4 0 0 1 1.18-.83l9-4.15a4 4 0 0 1 3.36 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blocksIconFront",
    d: "M55 45.15v10.89a4 4 0 0 1-2.32 3.63l-9 4.15a4 4 0 0 1-3.36 0l-9-4.15A4 4 0 0 1 29 56.04V45.15a4 4 0 0 1 .35-1.62L42 49.37l12.65-5.84a4 4 0 0 1 .35 1.62zm-11.32-7.78l9 4.15a4 4 0 0 1 1.17.83L42 47.82l-11.86-5.47a4 4 0 0 1 1.18-.83l9-4.15a4 4 0 0 1 3.36 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blocksIconFront",
    d: "M55 45.15v10.89a4 4 0 0 1-2.32 3.63l-9 4.15a4 4 0 0 1-3.36 0l-9-4.15A4 4 0 0 1 29 56.04V45.15a4 4 0 0 1 .35-1.62L42 49.37l12.65-5.84a4 4 0 0 1 .35 1.62zm-11.32-7.78l9 4.15a4 4 0 0 1 1.17.83L42 47.82l-11.86-5.47a4 4 0 0 1 1.18-.83l9-4.15a4 4 0 0 1 3.36 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blocksIconFront",
    d: "M55 45.15v10.89a4 4 0 0 1-2.32 3.63l-9 4.15a4 4 0 0 1-3.36 0l-9-4.15A4 4 0 0 1 29 56.04V45.15a4 4 0 0 1 .35-1.62L42 49.37l12.65-5.84a4 4 0 0 1 .35 1.62zm-11.32-7.78l9 4.15a4 4 0 0 1 1.17.83L42 47.82l-11.86-5.47a4 4 0 0 1 1.18-.83l9-4.15a4 4 0 0 1 3.36 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blocksIconFront",
    d: "M55 45.15v10.89a4 4 0 0 1-2.32 3.63l-9 4.15a4 4 0 0 1-3.36 0l-9-4.15A4 4 0 0 1 29 56.04V45.15a4 4 0 0 1 .35-1.62L42 49.37l12.65-5.84a4 4 0 0 1 .35 1.62zm-11.32-7.78l9 4.15a4 4 0 0 1 1.17.83L42 47.82l-11.86-5.47a4 4 0 0 1 1.18-.83l9-4.15a4 4 0 0 1 3.36 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blocksIconFront",
    d: "M55 45.15v10.89a4 4 0 0 1-2.32 3.63l-9 4.15a4 4 0 0 1-3.36 0l-9-4.15A4 4 0 0 1 29 56.04V45.15a4 4 0 0 1 .35-1.62L42 49.37l12.65-5.84a4 4 0 0 1 .35 1.62zm-11.32-7.78l9 4.15a4 4 0 0 1 1.17.83L42 47.82l-11.86-5.47a4 4 0 0 1 1.18-.83l9-4.15a4 4 0 0 1 3.36 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blocksIconFront",
    d: "M55 45.15v10.89a4 4 0 0 1-2.32 3.63l-9 4.15a4 4 0 0 1-3.36 0l-9-4.15A4 4 0 0 1 29 56.04V45.15a4 4 0 0 1 .35-1.62L42 49.37l12.65-5.84a4 4 0 0 1 .35 1.62zm-11.32-7.78l9 4.15a4 4 0 0 1 1.17.83L42 47.82l-11.86-5.47a4 4 0 0 1 1.18-.83l9-4.15a4 4 0 0 1 3.36 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blocksIconFront",
    d: "M55 45.15v10.89a4 4 0 0 1-2.32 3.63l-9 4.15a4 4 0 0 1-3.36 0l-9-4.15A4 4 0 0 1 29 56.04V45.15a4 4 0 0 1 .35-1.62L42 49.37l12.65-5.84a4 4 0 0 1 .35 1.62zm-11.32-7.78l9 4.15a4 4 0 0 1 1.17.83L42 47.82l-11.86-5.47a4 4 0 0 1 1.18-.83l9-4.15a4 4 0 0 1 3.36 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blocksIconFront",
    d: "M55 45.15v10.89a4 4 0 0 1-2.32 3.63l-9 4.15a4 4 0 0 1-3.36 0l-9-4.15A4 4 0 0 1 29 56.04V45.15a4 4 0 0 1 .35-1.62L42 49.37l12.65-5.84a4 4 0 0 1 .35 1.62zm-11.32-7.78l9 4.15a4 4 0 0 1 1.17.83L42 47.82l-11.86-5.47a4 4 0 0 1 1.18-.83l9-4.15a4 4 0 0 1 3.36 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "blocksIconFront",
    d: "M55 45.15v10.89a4 4 0 0 1-2.32 3.63l-9 4.15a4 4 0 0 1-3.36 0l-9-4.15A4 4 0 0 1 29 56.04V45.15a4 4 0 0 1 .35-1.62L42 49.37l12.65-5.84a4 4 0 0 1 .35 1.62zm-11.32-7.78l9 4.15a4 4 0 0 1 1.17.83L42 47.82l-11.86-5.47a4 4 0 0 1 1.18-.83l9-4.15a4 4 0 0 1 3.36 0z"
  }))), /*#__PURE__*/React.createElement("use", {
    "data-js-target": "BlocksIcon.firstHiddenBlock",
    href: "#blocksIconFront",
    transform: "translate(-13, -6)",
    style: {
      visibility: "hidden"
    }
  }), /*#__PURE__*/React.createElement("use", {
    "data-js-target": "BlocksIcon.secondHiddenBlock",
    href: "#blocksIconFront",
    transform: "translate(-65, -30)",
    style: {
      visibility: "hidden"
    }
  }), /*#__PURE__*/React.createElement("use", {
    "data-js-target-list": "BlocksIcon.secondBackBlocks",
    href: "#blocksIconFront",
    fill: "#00D4FF",
    style: {
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("use", {
    "data-js-target-list": "BlocksIcon.secondFrontBlocks",
    href: "#blocksIconFront",
    fill: "#7A73FF",
    style: {
      opacity: 0
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    "data-js-target-list": "BlocksIcon.firstBackBlocks",
    href: "#blocksIconFront",
    fill: "#00D4FF",
    transform: "translate(-13, -6)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    "data-js-target-list": "BlocksIcon.firstFrontBlocks",
    href: "#blocksIconFront",
    fill: "#7A73FF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#blocksIconClipPath)"
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    "data-js-target-list": "BlocksIcon.firstFrontBlocks",
    href: "#blocksIconFront",
    fill: "#CCFFFF"
  })), /*#__PURE__*/React.createElement("use", {
    "data-js-target-list": "BlocksIcon.secondFrontBlocks",
    href: "#blocksIconFront",
    fill: "#CCFFFF",
    style: {
      opacity: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedBox);
export default __webpack_public_path__ + "static/media/animated-box.7667afd82e106e6be4b8bfd1c97e0188.svg";
export { ForwardRef as ReactComponent };